import { createUserCountryCache, getArgentinaDiscountValue } from "../commons/commonPricing";
import { getConvertedValue } from "../pricingSelector";

var pricingStore;

const applyDiscount = (amount, discountPercentage)  => {
  const discount = (amount * discountPercentage) / 100;
  const finalAmount = amount - discount;
  return finalAmount;
}

const getUserCountry = async () => {
  const getUserCountryCached = await createUserCountryCache();
  const userCountry = await getUserCountryCached();
  return userCountry;
}

const checkUserApplyDiscount = async () =>{
  const userCountry = await getUserCountry();
  const { currentCurrency : userCurrency } = pricingStore.getState();
  const validCountryDiscount = ['AR']
  const validCurrencyDiscount = ['ARS','USD']

  const isValidUserCountry = validCountryDiscount.includes(userCountry);
  const isValidUserCurrency = validCurrencyDiscount.includes(userCurrency);
  const isValidDiscountAmount = document.getElementById('specialDiscountArg').value > 0;

  return isValidUserCountry && isValidUserCurrency && isValidDiscountAmount;
}

const addCardsHeight = () => {
  const planCards = document.querySelectorAll('.plan-card span.plan-pricing');
  planCards.forEach( card => {
    card.classList.add('card--min-height')
  })
};

const removeCardsHeight = () => {
  const planCards = document.querySelectorAll('.plan-card span.plan-pricing');
  planCards.forEach( card => {
    card.classList.remove('card--min-height')
  })
};

const updatePriceContainers = (oldValue, newValue, currencySymbol) => {
  document.querySelectorAll('.parentCurrencyDiscount').forEach(container => {
    const oldPriceContainer = container.querySelector('.old-price__container');
    const oldPriceMessageContainer = container.querySelector('.old-price-message__container');
    const valueToApplyDiscount = container.querySelector('.valueToApplyDiscount');
    oldPriceContainer.innerHTML = currencySymbol + oldValue;
    valueToApplyDiscount.innerHTML = newValue;
    oldPriceContainer.classList.add('show');
    oldPriceMessageContainer.classList.add('show');
  });
};

const clearPriceContainers = () => {
  document.querySelectorAll('.parentCurrencyDiscount').forEach(container => {
    const oldPriceContainer = container.querySelector('.old-price__container');
    const oldPriceMessageContainer = container.querySelector('.old-price-message__container');
    oldPriceContainer.classList.remove('show');
    oldPriceMessageContainer.classList.remove('show');
  });
};

const trimDiscount = () => {
  clearPriceContainers();
  removeCardsHeight();
};

const applyArgentinaDiscount =  async (pricingStoreRef) => {

  pricingStore = pricingStoreRef;
  const isUserApplyDiscount = await checkUserApplyDiscount();
  if(!isUserApplyDiscount) return;
  const dataToApplyDiscount = document.getElementById('valueToApplyDiscount');
  const roundingDecimals = dataToApplyDiscount.getAttribute('roundingDecimals');
  const usdValueToDiscount = dataToApplyDiscount.value;

  const discountValueForArgentina = getArgentinaDiscountValue();
  const { currentCurrency , currenciesData} = pricingStore.getState();
  const currentCurrencySymbol = currenciesData[currentCurrency].currencySymbol;

  const valueWithDiscount = applyDiscount (usdValueToDiscount, discountValueForArgentina);

  const oldValue = getConvertedValue(usdValueToDiscount, currentCurrency, roundingDecimals);
  const newValue = getConvertedValue(valueWithDiscount, currentCurrency, roundingDecimals);


  updatePriceContainers(oldValue, newValue, currentCurrencySymbol);
  addCardsHeight();

}


export {
  trimDiscount,
  applyArgentinaDiscount
}
